import React from 'react'
import FreebieEntitlement from './FreebieEntitlement'
import PurchaseConditions from '../AmountOff/PurchaseConditions'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountApplicationRulesFreebie = () => {
  const { t } = useLocale()
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex flex-col gap-3'>
        <h3 className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.set_discount')}</h3>
        <FreebieEntitlement />
      </div>
      <PurchaseConditions />
      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesFreebie
